import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import {useTranslation} from 'react-i18next';

import {TOUR_STAGES} from '@explorer/constants';

const Footer = props => {
  const {t} = useTranslation();

  const onAPIClick = () => {
    props.openApiDialog();
  };

  return (
    <AppBar position="static" elevation={0} color="inherit">
      <Divider />
      <CardActions
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Button color="primary" onClick={onAPIClick} data-cy="api-button">
          {t('resultsFooter.buttonApiDetails')}
        </Button>
        <Tooltip
          title={
            props.count === 0 ? t('resultsFooter.tooltipSelectToOrder') : ''
          }
        >
          <span>
            <Button
              color="primary"
              variant="contained"
              disabled={props.count === 0}
              onClick={props.onOrderClick}
              data-qe="order-button"
              data-tour={TOUR_STAGES.ORDER_BUTTON}
            >
              {t('resultsFooter.orderScenes', 'Order Scenes ({{count}})', {
                count: props.count,
              })}
            </Button>
          </span>
        </Tooltip>
      </CardActions>
    </AppBar>
  );
};

Footer.propTypes = {
  count: PropTypes.number,
  onOrderClick: PropTypes.func,
  openApiDialog: PropTypes.func,
};

export default Footer;
